import { NetworkTypeEnum } from '../../Core/enums/network-type.enum';
import { MediaSubscriptionMediaTypeEnum } from '../../../api/mediaSubscriptions/enums/media-subscription-media-type.enum';
import { MediaRequestType } from '../../../api/mediaSubscriptions/enums/media-subscription-media-type.enum';
import { MediaTypeEnum } from '../../../Common/Basic/enums/media-type.enum';

export const networkTypeToMediaSubTypeMap = new Map<NetworkTypeEnum, MediaRequestType>([
    [ NetworkTypeEnum.twitter,   MediaSubscriptionMediaTypeEnum.twitter   ],
    [ NetworkTypeEnum.subReddit, MediaSubscriptionMediaTypeEnum.subReddit ],
    [ NetworkTypeEnum.facebook,  MediaTypeEnum.FACEBOOK                   ],
    [ NetworkTypeEnum.instagram, MediaTypeEnum.INSTAGRAM                  ],
    [ NetworkTypeEnum.youtube,   MediaTypeEnum.YOUTUBE                    ],
    [ NetworkTypeEnum.reddit,    MediaTypeEnum.REDDIT                     ],
    [ NetworkTypeEnum.tiktok,    MediaTypeEnum.TIKTOK                     ],
    [ NetworkTypeEnum.linkedin,  MediaTypeEnum.LINKEDIN                   ],
    [ NetworkTypeEnum.bluesky,   MediaTypeEnum.BLUESKY                    ],
]);

export const mediaSubTypeToNetworkTypeMap = new Map<MediaRequestType, NetworkTypeEnum>([
    [ MediaSubscriptionMediaTypeEnum.twitter,   NetworkTypeEnum.twitter   ],
    [ MediaSubscriptionMediaTypeEnum.subReddit, NetworkTypeEnum.subReddit ],
    [ MediaTypeEnum.FACEBOOK,                   NetworkTypeEnum.facebook  ],
    [ MediaTypeEnum.INSTAGRAM,                  NetworkTypeEnum.instagram ],
    [ MediaTypeEnum.YOUTUBE,                    NetworkTypeEnum.youtube   ],
    [ MediaTypeEnum.REDDIT,                     NetworkTypeEnum.reddit    ],
    [ MediaTypeEnum.TIKTOK,                     NetworkTypeEnum.tiktok    ],
    [ MediaTypeEnum.LINKEDIN,                   NetworkTypeEnum.linkedin  ],
    [ MediaTypeEnum.BLUESKY,                    NetworkTypeEnum.bluesky   ],
]);
